import React, { useState, useEffect } from "react";
import Link from "antd/es/typography/Link";
import { message } from "antd";
import { handleDeleteItem } from "./HandleDeleteFunction";
import { useDispatch, useSelector } from "react-redux";
import { setManagersDatas } from "../../Slices/employeeslice";
import { SelectInput } from "../../blueplanitUtils/InputField";
import Modal from "../../blueplanitUtils/Modal";
import { handleClose } from "./HandleClosePop/handleclose";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { getOptionsByPath, useNestedDropdownHandler } from "../../utilsdata";
import { EMPLOYEE_DEPARTMENT,ADD_EDIT_EMPLOYEE } from "../../Dropdownmanager";
export const ReportingManagerPopUp = () => {
    const dispatch = useDispatch();
    const { handleSubmit } = useFormHandler()
    const [managersData, setManagersData] = useState([]);
    const AllEmployees = useSelector((state) => state.employee.AllEmployees);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

    const Departmentoptions = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT]);
    const { selectedId,handleChange } = useNestedDropdownHandler(Departmentoptions, "department");
    const managers = useSelector((state) => state.employee.managersData);
    const [isManagerFormValid, setIsManagerFormValid] = useState(false);
    const [managerErrors, setManagerErrors] = useState({});

    const validateManagerFields = (managers) => {
        const errors = {};

        managers.forEach((manager, index) => {
            const managerErrors = {};

            if (!manager.reportingManagerName?.trim()) {
                managerErrors.reportingManagerName = "Reporting Manager Name is required.";
            }


            if (!manager.reportingManagerDepartment) {
                managerErrors.reportingManagerDepartment = "Reporting Manager Department is required.";
            }

            if (!manager.reportingManagerDesignation) {
                managerErrors.reportingManagerDesignation = "Reporting Manager Designation is required.";
            }

            if (Object.keys(managerErrors).length > 0) {
                errors[index] = managerErrors; // Store errors per manager index
            }
        });

        return errors;
    };


    const handleManagerInputChange = (index, e) => {
        const { name, value } = e.target;

        const updatedManagersData = [...managersData];

        if (name === "reportingManagerName") {
            const selectedEmployee = AllEmployees.find(emp => `${emp?.firstname} ${emp?.lastname}` === value);

            updatedManagersData[index] = {
                ...updatedManagersData[index],
                reportingManagerName: value,
                reportingManagerDesignation: selectedEmployee?.designation || "",
                reportingManagerDepartment: selectedEmployee?.department || "",
                 reportingId: selectedEmployee.id,
            };
        } else {
            updatedManagersData[index] = {
                ...updatedManagersData[index],
                [name]: value,
            };
        }

        setManagersData(updatedManagersData);

        const newErrors = validateManagerFields(updatedManagersData);
        setManagerErrors(newErrors);

        const allFieldsValid = updatedManagersData.every((manager, i) => {
            const recordErrors = newErrors[i] || {};
            return (
                manager.reportingManagerName?.trim() &&
                manager.reportingManagerDepartment &&
                manager.reportingManagerDesignation &&
                Object.keys(recordErrors).length === 0
            );
        });

        setIsManagerFormValid(allFieldsValid);
    };

    // Add New Manager Entry
    const addManager = () => {
        const newManager = {
            reportingManagerName: "",
            reportingManagerType: "",
            reportingManagerDepartment: "",
            reportingManagerDesignation: "",
        };

        // Ensure prev is an array before spreading
        setManagersData((prev) => Array.isArray(prev) ? [...prev, newManager] : [newManager]);
        setIsManagerFormValid(false);
    };
    // Delete Manager Entry
    const deleteManager = (index) => {
        handleDeleteItem(index, managersData, setManagersData, managerErrors, setManagerErrors, setIsManagerFormValid);
    };


    const handleManagerSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validateManagerFields(managersData);
        setManagerErrors(newErrors);
        const noErrors = Object.keys(newErrors).length === 0;
        setIsManagerFormValid(noErrors)

        const formattedManagersData = managersData?.map(({ __typename, ...manager }) => manager);
        const input = { teamsReportIngManager: formattedManagersData }
        try {
            const val = await handleSubmit({
                noErrors,
                formValid: isManagerFormValid,
                dataObj: input,
                action: "ReportingManager",
                ModalName: "ReportungManagerModelpopUp",
                submitAction: "handleReportingManagerSubmit",
            });
            if (val) {
                dispatch(setManagersDatas(formattedManagersData));
                setIsManagerFormValid(false)
            }
        } catch (error) {
            message.error({
                content: "Failed to update handleManagerSubmit . Please try again.",
                duration: 5,
                className: "custom-toast-center",
            });
        } finally {

            setIsManagerFormValid(false); // Ensure form state resets
        }
    };

    const names = AllEmployees
        .filter(item => item.employeestatus === "Active")
        .map((item, index) => ({
            key: index,
            label: `${item.firstname} ${item.lastname}`,
            value: `${item.firstname} ${item.lastname}`,
        }));


    useEffect(() => {
        setManagersData(managers);
    }, [managers])



    return (
        <Modal id="reporting_manager"
            title="Reporting Manager Information"
            handleSubmit={handleManagerSubmit}
            handleModalClose={() =>
                handleClose(managers,
                    setManagersData,
                    setManagerErrors,
                    setIsManagerFormValid
                )}
            isUserDataValid={false} >
            {managersData?.map((manager, index) => (
                <div className="card" key={index}>
                    <div className="card-body">
                        <h3 className="card-title">
                            Reporting Manager Information {index + 1}
                            <Link to="#" className="delete-icon" onClick={() => deleteManager(index)}>
                                <i className="fa-regular fa-trash-can" />
                            </Link>
                        </h3>
                        <div className="row">
                            <div className="col-md-6 mb-2"> {/* Added margin-bottom for consistency */}
                                <SelectInput
                                    label="Name"
                                    name="Name"
                                    value={manager?.reportingManagerName}
                                    onChange={(e) =>
                                        handleManagerInputChange(index, {
                                            target: {
                                                name: "reportingManagerName",
                                                value: e,
                                            }
                                        })
                                    }
                                    formControl={true}
                                    options={names.filter(
                                        (n) =>
                                            !managersData.some((m, i) =>
                                                i !== index && m.reportingManagerName === n.value
                                            )
                                    )}
                                    style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                    error={managerErrors[index]?.reportingManagerName}
                                />

                            </div>
                            <div className="col-md-6">
                                <SelectInput
                                    label="Designation"
                                    name="reportingManagerDesignation"
                                    value={manager?.reportingManagerDesignation}
                                    disabled={true}
                                    onChange={(e) =>
                                        handleManagerInputChange(index, {
                                            target: {
                                                name: "reportingManagerDesignation",
                                                value: e,
                                            }
                                        })
                                    }
                                    formControl={true}
                                    options={getOptionsByPath(NestedDatabucket, [...[ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT], selectedId])}
                                    style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                    error={managerErrors[index]?.reportingManagerDesignation}

                                />
                            </div>
                            <div className="col-md-6">
                                <SelectInput
                                    label="Department"
                                    name="reportingManagerDepartment"
                                    value={manager?.reportingManagerDepartment}
                                    onChange={(value) => handleChange(value, 'reportingManagerDepartment', handleManagerInputChange)}
                                    formControl={true}
                                    disabled={true}
                                    options={Departmentoptions}
                                    style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                    error={managerErrors[index]?.reportingManagerDepartment}

                                />
                            </div>

                        </div>
                    </div>
                </div>
            ))}
            <div className="add-more">
                <Link to="#" onClick={addManager}>
                    <i className="fa-solid fa-plus-circle" /> Add More
                </Link>
            </div>
        </Modal>
    )
}